import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { OutlineLink } from "./OutlineLink";
import { SectionDescription } from "./SectionDescription";
import { LayoutContainer } from "./LayoutContainer";
import { graphql, useStaticQuery } from "gatsby";

export const BottomBanner = () => {
  const rawData = useStaticQuery(graphql`
    query {
      sanityFooterBannerSettings {
        title
        secondaryImage {
          asset {
            gatsbyImageData(fit: FILL, placeholder: NONE)
          }
        }
        ctaButton {
          label
          url
        }
        description
        prefix
        mascotImage {
          asset {
            gatsbyImageData(fit: FILL, placeholder: NONE)
          }
        }
      }
    }
  `);

  const data = rawData.sanityFooterBannerSettings

  return (
    <LayoutContainer parentClassName="relative overflow-hidden">
      <span className="bg-gradient-to-r from-brand-eight to-brand-seven absolute inset-0 opacity-20 -z-10" />
      <div className="relative py-16 sm:py-24 px-10 sm:px-0">
        <div className="sm:grid grid-cols-8">
          <span className="col-span-2" />
          <div className="col-span-4">
            <SectionDescription
              smallTitle={data.prefix}
              bigTitle={data.title}
              description={data.description}
            />
            <div className="-mt-5">
              <OutlineLink
                label={data.ctaButton.label}
                to={data.ctaButton.url}
              />
            </div>
          </div>
        </div>
        <GatsbyImage
          alt=""
          image={getImage(data.mascotImage.asset)!}
          className="bottom-0 -z-10 right-0 blur-3xl sm:blur-none opacity-30 sm:opacity-100 sm:left-0 absolute w-72"
        />
        <GatsbyImage
          alt=""
          imgStyle={{ transition: 'none' }}
          image={getImage(data.secondaryImage.asset)!}
          className="bottom-0 -z-10 -mb-10 right-0 absolute w-96 hidden sm:block"
        />
      </div>
    </LayoutContainer>
  );
};
